const initialState = {
  quote: null,
};

const quoteReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_QUOTE_DATA':
      return {
        ...state,
        quote: {
          ...state.quote,
          ...action.payload,
        },
      };
    case 'ADD_QUOTE_IMAGE':
      return {
        ...state,
        quote: {
          ...state.quote,
          image: action.payload,
        },
      };
    case 'UPDATE_VALUE':
      const { type, heading, option } = action.payload;
      const updatedData = state.quote?.[type].data.map((item) => {
        if (item.heading === heading) {
          return {
            ...item,
            value: [...item.value, option],
          };
        }
        return item;
      });
      return {
        ...state,
        quote: {
          ...state.quote,
          [type]: {
            ...state.quote?.[type],
            data: updatedData,
          },
        },
      };
    case 'DELETE_VALUE':
      const { deleteType, deleteHeading, index } = action.payload;
      const deletedData = state?.quote[deleteType]?.data?.map((item) => {
        if (item.heading === deleteHeading) {
          // Remove the option at the specified index from the value array
          const updatedValue = item.value.filter((_, i) => i !== index);
          return {
            ...item,
            value: updatedValue,
          };
        }
        return item;
      });
      return {
        ...state,
        quote: {
          ...state.quote,
          [deleteType]: {
            ...state.quote[deleteType],
            data: deletedData,
          },
        },
      };
    default:
      return state;
  }
};

export default quoteReducer;
